var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileRtfBw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 63,
    viewBox: "0 0 50 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__Canvas",
    transform: "translate(10415 -935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__file-rtf-bw"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__file-rtf"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__Canvas"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__rtf"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-rtf-bw_svg__file-rtf-bw_svg__path0_fill",
    transform: "translate(-10415 935)",
    fill: "#D9DEE0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__Burger_Angus_Burger"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-rtf-bw_svg__file-rtf-bw_svg__path1_fill",
    transform: "translate(-10398.4 980.362)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-rtf-bw_svg__file-rtf-bw_svg__path2_fill",
    transform: "translate(-10392.8 980.362)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-rtf-bw_svg__file-rtf-bw_svg__path3_fill",
    transform: "translate(-10385.7 980.362)",
    fill: "#FFFFFF"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__Rectangle_11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -10395.4 959.146L -10376.4 959.146L -10376.4 960.871L -10395.4 960.871L -10395.4 959.146Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-rtf-bw_svg__file-rtf-bw_svg__path4_fill",
    transform: "matrix(1 0 0 -1 -10395.4 960.871)",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__Rectangle_11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -10395.4 962.595L -10376.4 962.595L -10376.4 964.319L -10395.4 964.319L -10395.4 962.595Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-rtf-bw_svg__file-rtf-bw_svg__path4_fill",
    transform: "matrix(1 0 0 -1 -10395.4 964.319)",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__Rectangle_11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -10404 966.043L -10376.4 966.043L -10376.4 967.768L -10404 967.768L -10404 966.043Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-rtf-bw_svg__file-rtf-bw_svg__path5_fill",
    transform: "matrix(1 0 0 -1 -10404 967.768)",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__Rectangle_11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -10404 969.492L -10383.3 969.492L -10383.3 971.216L -10404 971.216L -10404 969.492Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-rtf-bw_svg__file-rtf-bw_svg__path6_fill",
    transform: "matrix(1 0 0 -1 -10404 971.216)",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__T"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-rtf-bw_svg__file-rtf-bw_svg__path7_fill",
    transform: "translate(-10404 955.696)",
    fill: "#D9DEE0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__Rectangle_11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -10395.4 955.693L -10376.4 955.693L -10376.4 957.418L -10395.4 957.418L -10395.4 955.693Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-rtf-bw_svg__file-rtf-bw_svg__path4_fill",
    transform: "matrix(1 0 0 -1 -10395.4 957.418)",
    fill: "#FFFFFF"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__path0_fill",
    d: "M 35.7148 0L 3.57078 0C 1.60081 0 -1.60235e-16 1.55103 -1.60235e-16 3.46966L -1.60235e-16 58.5993C -1.60235e-16 60.5159 1.60081 62.069 3.57078 62.069L 46.4293 62.069C 48.4034 62.069 50 60.5159 50 58.5993L 50 13.8786L 35.7148 0ZM 35.7148 4.90552L 44.9512 13.8786L 35.7148 13.8786L 35.7148 4.90552ZM 46.43 58.5993L 3.57078 58.5993L 3.57078 3.46966L 32.1433 3.46966L 32.1433 13.8786C 32.1433 15.7952 33.7405 17.3483 35.7141 17.3483L 46.4293 17.3483L 46.4293 58.5993L 46.43 58.5993Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__path1_fill",
    d: "M 5.24483 7.25172C 5.31379 7.36207 5.34828 7.47586 5.34828 7.5931C 5.34828 7.73103 5.3 7.84828 5.20345 7.94483C 5.11379 8.03448 4.98966 8.07931 4.83103 8.07931C 4.63103 8.07931 4.47586 7.9931 4.36552 7.82069L 2.58621 4.96552L 2.4 4.96552L 1.07586 4.96552L 1.07586 7.54138C 1.07586 7.6931 1.02414 7.82069 0.92069 7.92414C 0.824138 8.02759 0.696552 8.07931 0.537931 8.07931C 0.386207 8.07931 0.258621 8.02759 0.155172 7.92414C 0.0517241 7.82069 0 7.6931 0 7.54138L 0 0.537931C 0 0.37931 0.0517241 0.251724 0.155172 0.155172C 0.258621 0.0517241 0.386207 0 0.537931 0L 2.4 0C 2.91034 0 3.36552 0.106897 3.76552 0.32069C 4.17241 0.534483 4.48621 0.834483 4.7069 1.22069C 4.93448 1.6069 5.04828 2.04828 5.04828 2.54483C 5.04828 3.03448 4.92414 3.46897 4.67586 3.84828C 4.42759 4.22759 4.08966 4.51379 3.66207 4.7069L 5.24483 7.25172ZM 2.4 3.97241C 2.86897 3.97241 3.25517 3.84138 3.55862 3.57931C 3.86207 3.31034 4.01379 2.96552 4.01379 2.54483C 4.01379 2.08966 3.86207 1.71724 3.55862 1.42759C 3.25517 1.13793 2.86897 0.993103 2.4 0.993103L 1.07586 0.993103L 1.07586 3.97241L 2.4 3.97241Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__path2_fill",
    d: "M 6.03103 0C 6.17586 0 6.2931 0.0482759 6.38276 0.144828C 6.47931 0.234483 6.52759 0.351724 6.52759 0.496552C 6.52759 0.641379 6.47931 0.762069 6.38276 0.858621C 6.2931 0.948276 6.17586 0.993103 6.03103 0.993103L 3.8069 0.993103L 3.8069 7.54138C 3.8069 7.6931 3.75517 7.82069 3.65172 7.92414C 3.54828 8.02759 3.42069 8.07931 3.26897 8.07931C 3.11724 8.07931 2.98966 8.02759 2.88621 7.92414C 2.78276 7.82069 2.73103 7.6931 2.73103 7.54138L 2.73103 0.993103L 0.496552 0.993103C 0.351724 0.993103 0.231034 0.948276 0.134483 0.858621C 0.0448276 0.762069 -1.27464e-07 0.641379 -1.27464e-07 0.496552C -1.27464e-07 0.351724 0.0448276 0.234483 0.134483 0.144828C 0.231034 0.0482759 0.351724 0 0.496552 0L 6.03103 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__path3_fill",
    d: "M 0.537931 8.07931C 0.386207 8.07931 0.258621 8.02759 0.155172 7.92414C 0.0517242 7.82069 -2.47561e-07 7.6931 -2.47561e-07 7.54138L -2.47561e-07 0.537931C -2.47561e-07 0.37931 0.0517242 0.251724 0.155172 0.155172C 0.258621 0.0517241 0.386207 0 0.537931 0L 5.21378 0C 5.3724 0 5.49998 0.0482759 5.59653 0.144828C 5.69309 0.234483 5.74136 0.355172 5.74136 0.506897C 5.74136 0.651724 5.69309 0.768966 5.59653 0.858621C 5.49998 0.948276 5.3724 0.993103 5.21378 0.993103L 1.07586 0.993103L 1.07586 3.5069L 4.04483 3.5069C 4.19655 3.5069 4.32069 3.55517 4.41724 3.65172C 4.52067 3.74138 4.5724 3.85862 4.5724 4.00345C 4.5724 4.14828 4.52067 4.26897 4.41724 4.36552C 4.32069 4.45517 4.19655 4.5 4.04483 4.5L 1.07586 4.5L 1.07586 7.54138C 1.07586 7.6931 1.02414 7.82069 0.920689 7.92414C 0.817241 8.02759 0.689655 8.07931 0.537931 8.07931Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__path4_fill",
    d: "M 0 0L 18.9654 0L 18.9654 1.72463L 0 1.72463L 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__path5_fill",
    d: "M 0 0L 27.5861 0L 27.5861 1.72463L 0 1.72463L 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__path6_fill",
    d: "M 0 0L 20.6896 0L 20.6896 1.72463L 0 1.72463L 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-rtf-bw_svg__file-rtf-bw_svg__path7_fill",
    d: "M 6.89652 0L 6.89652 1.5269L 4.34931 1.5269L 4.34931 8.62317L 2.55876 8.62317L 2.55876 1.5269L 0 1.5269L 0 0L 6.89652 0Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileRtfBw);
export default __webpack_public_path__ + "static/media/file-rtf-bw.9c7d07b2063680248a1130c614be0487.svg";
export { ForwardRef as ReactComponent };